import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const REASONS = [
  {
    n: "01",
    title: "Constrained Bank Lending",
    body:
      "Retrenchment in traditional bank credit has widened the financing gap for asset-backed industrial borrowers.",
  },
  {
    n: "02",
    title: "Re-Pricing of Risk",
    body:
      "Higher base rates and tighter spreads create disciplined entry points for senior-secured private credit.",
  },
  {
    n: "03",
    title: "Industrial Reshoring",
    body:
      "Long-cycle capital expenditure across energy transition, logistics and onshoring is creating durable demand for structured capital.",
  },
];

const WhyNow = () => {
  return (
    <section
      data-testid={LANDING.whyNow}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)]"
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12">
        <SectionHeading
          index="08"
          label="Why Now"
          title={
            <>
              A structural dislocation across
              <br />
              <span className="italic text-[var(--kr-gold)]">
                industrial capital
              </span>{" "}
              formation.
            </>
          }
        />

        <div className="mt-20 grid md:grid-cols-3 gap-0 border-t border-[var(--kr-line)]">
          {REASONS.map((r, idx) => (
            <div
              key={r.n}
              className={`py-12 px-2 md:px-10 ${
                idx < REASONS.length - 1
                  ? "md:border-r border-[var(--kr-line)]"
                  : ""
              }`}
            >
              <span className="font-mono-label text-[10px] text-[var(--kr-gold)] block mb-6">
                {r.n}
              </span>
              <h3 className="font-serif-display text-[1.7rem] text-[var(--kr-text)] mb-5">
                {r.title}
              </h3>
              <p className="text-[var(--kr-text-muted)] text-[15px] leading-[1.75]">
                {r.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNow;
